
























import { Component, Vue, Prop } from 'vue-property-decorator'
import Modal from '@/components/Modal/Modal.vue'
import { Icon, Card } from '@alpha/ink'
import EditActions from '@/components/EditActions.vue'
import { Stages } from '@/components/AudienceBuilder/AudienceBuilder.vue'

@Component({
  components: {
    Modal,
    EditActions,
    Card,
    Icon
  }
})
export default class EditModal extends Vue {
  @Prop({ default: '' }) title!: string
  @Prop({ default: false }) loading!: boolean
  @Prop() stage!: Stages
}
